import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

export const getGobUnidades = query =>
	fetch.get(
		`/gob-unidades${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getGobUnidad = ({ id, query }) =>
	fetch.get(
		`/gob-unidades/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{ encodeValuesOnly: true }
				  )}`
				: ''
		}`
	);
export const addGobUnidad = data => fetch.post('/gob-unidades', data);
export const updateGobUnidad = ({ id, ...data }) =>
	fetch.put(`/gob-unidades/${id}`, data);
export const deleteGobUnidad = id => fetch.delete(`/gob-unidades/${id}`);

// RTK Query
export const gobUnidadesApi = createApi({
	reducerPath: 'gobUnidadesApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getGobUnidades: build.query({
			query: query => {
				return {
					url: `/gob-unidades${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'GobUnidades',
								id,
							})),
							{ type: 'GobUnidades', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'GobUnidades', id: 'LIST' }],
		}),
		getGobUnidad: build.query({
			query: ({ id, query }) => {
				return {
					url: `/gob-unidades/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'GobUnidades', id }],
		}),
		addGobUnidad: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/gob-unidades`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Unidad Gobierno agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar unidad gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'GobUnidades', id: 'LIST' }],
		}),
		updateGobUnidad: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/gob-unidades/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Unidad Gobierno actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar unidad gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'GobUnidades', id },
			],
		}),
		deleteGobUnidad: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/gob-unidades/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Unidad Gobierno eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar unidad gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'GobUnidades', id }],
		}),
	}),
});

export const {
	useGetGobUnidadesQuery,
	useGetGobUnidadQuery,
	useAddGobUnidadMutation,
	useUpdateGobUnidadMutation,
	useDeleteGobUnidadMutation,
} = gobUnidadesApi;
